import React, { forwardRef } from "react";
import {
  Dialog as MuiDialog,
  DialogTitle,
  IconButton,
  Grow,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const Transition = forwardRef(function Transition(props, ref) {
  return <Grow ref={ref} {...props} timeout={400} />;
});

export default function Dialog(props) {
  const {
    show,
    setShow,
    maxWidth = "sm",
    children,
    onClose = true,
    fullScreen = false,
    ...other
  } = props;

  const handleClose = () => {
    // Move focus to body to prevent focus issues
    document.activeElement?.blur();
    setShow !== undefined && onClose && setShow(false);
  };

  return (
    <MuiDialog
      disableEnforceFocus
      open={show}
      TransitionComponent={Transition}
      keepMounted
      fullScreen={fullScreen}
      onClose={handleClose}
      aria-describedby="dialog"
      PaperProps={{
        className: "bg-white !m-3 !md:m-6 w-full",
      }}
      maxWidth={maxWidth}
      {...other}
    >
      {setShow !== undefined && (
        <DialogTitle className="text-right p-10">
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
      )}
      {children}
    </MuiDialog>
  );
}
